module.exports = __webpack_public_path__ + "static/section-line-top-c0f1216aae21fafb17e33dbbc9e98975.webp";